<template>
  <div>
    <slot v-if="ready"></slot>
    <LImageOverlay :bounds="bounds"  :url="imageUrl(circle)" :interactive="true" :opacity="0.07"></LImageOverlay>
    <LAreaText ref="areaText" :title="text" :class-name="this.className" :small="this.textSmall" :visible="this.textVisible" :size="sizes" :lat-lng="latLng" ></LAreaText>
  </div>

</template>

<script>

import L from 'leaflet'
import propsBinder from 'vue2-leaflet/src/utils/propsBinder.js'
import findRealParent from 'vue2-leaflet/src/utils/findRealParent.js'
import { LImageOverlay } from 'vue2-leaflet'
import 'leaflet-path-transform'
// import 'leaflet.path.drag'
import LAreaText from '@/components/LAreaText' // eslint-disable-line

const props = {
  textSmall: {
    type: Boolean,
    custom: false,
    default: false
  },
  size: {
    type: Object,
    custom: true
  },
  latLng: {
    type: Object,
    custom: true
  },
  transformable: {
    type: Boolean,
    custom: true,
    default: false
  },
  circle: {
    type: Number,
    custom: true,
    default: 0
  },
  visible: {
    type: Boolean,
    custom: true,
    default: true
  },
  internal: {
    type: Boolean,
    custom: true,
    default: false
  },
  stroke: {
    type: Boolean,
    custom: true,
    default: true
  },
  opacity: {
    type: Number,
    custom: true,
    default: 1.0
  },
  fill: {
    type: Boolean,
    custom: true,
    default: false
  },
  fillOpacity: {
    type: Number,
    custom: true,
    default: 0
  },
  fillRule: {
    type: String,
    custom: true,
    default: 'evenodd'
  },
  className: {
    type: String,
    custom: true,
    default: null
  },
  draggable: {
    type: Boolean,
    custom: true,
    default: true
  },
  title: {
    type: String,
    custom: true
  }
}

export default {
  name: 'l-area',
  components: {
    LImageOverlay,
    LAreaText
  },
  props: props,
  data () {
    return {
      ready: false,
      bounds: null,
      boundsPoly: null,
      sizes: null,
      latLngs: null,
      text: this.title,
      textVisible: true
    }
  },
  created () {
    this.sizes = this.size
    this.latLngs = this.latLng
    this.updateArea(this.latLngs, this.sizes)
  },
  mounted () {
    const options = {}
    if (this.color) {
      options.color = this.color
    }
    if (this.lStyle) {
      for (var s in this.lStyle) {
        options[s] = this.lStyle[s]
      }
    }
    const otherPropertytoInitialize = ['smoothFactor', 'noClip', 'stroke', 'color', 'weight',
      'opacity', 'lineCap', 'lineJoin', 'dashArray', 'dashOffset', 'fill', 'fillColor',
      'fillOpacity', 'fillRule', 'className'
    ]
    for (var i = 0; i < otherPropertytoInitialize.length; i++) {
      const propName = otherPropertytoInitialize[i]
      if (this[propName] !== undefined) {
        options[propName] = this[propName]
      }
    }

    this.mapObject = L.polygon(this.boundsPoly, { interactive: true, stroke: 0, transform: true, draggable: true, fillOpacity: this.fillOpacity, options }) // eslint-disable-line

    L.DomEvent.on(this.mapObject, this.$listeners) // eslint-disable-line
    propsBinder(this, this.mapObject, props)
    this.ready = true
    this.parentContainer = findRealParent(this.$parent)
    this.parentContainer.addLayer(this, !this.visible)

    this.mapObject.dragging.disable()

    this.mapObject.on('dragend', this.onDragEnd)
    this.mapObject.on('dragstart', this.onDragStart)
    this.mapObject.on('scaleend', this.onScaleEnd)
    this.mapObject.on('scalestart', this.onScaleStart)
  },
  beforeDestroy () {
    this.mapObject.transform.disable()
    this.parentContainer.removeLayer(this)
  },
  methods: {

    onScaleEnd (event) {
      // console.log('onscaleend start')
      let height = Math.abs(this.mapObject.getBounds()._northEast.lat - this.mapObject.getBounds()._southWest.lat)
      let width = Math.abs(this.mapObject.getBounds()._southWest.lng - this.mapObject.getBounds()._northEast.lng)

      if (width === this.sizes.width && height === this.sizes.height) return

      let size = this.sizes
      size.height = height
      size.width = width

      this.sizes = size

      // Area aktualisieren
      this.updateArea(this.mapObject.getCenter(), this.sizes)
      // Event um Daten in Datenbank zu aktualisieren
      this.$emit('area-update', { size: size, latLng: this.mapObject.getCenter() })
    },

    imageUrl (number) {
      if (this.internal) {
        return require('@/assets/naturalCircle' + number + 'h.svg')
      }
      return require('@/assets/naturalCircle' + number + '.svg')
    },

    onDragStart (event) {
      this.mapObject.transform.disable()
      this.mapObject.transform.reset()
    },

    onScaleStart (event) {
      // this.mapObject.transform.removeHooks()
      // this.mapObject.transform.reset()
    },

    onDragEnd (event) {
      // Area aktualisieren
      // this.mapObject.transform.disable()
      this.mapObject.transform.enable()
      // this.mapObject.transform.enable()
      // this.updateArea(this.mapObject.getCenter(), this.sizes)
      // Event um Daten in Datenbank zu aktualisieren
      this.$emit('area-update', { size: this.sizes, latLng: this.mapObject.getCenter() })

      // this.mapObject.transform.reset()
      // this.mapObject.transform.addHooks()
    },

    setVisible (newVal, oldVal) {
      if (newVal === oldVal) return
      if (newVal) {
        this.parentContainer.addLayer(this)
      } else {
        this.parentContainer.removeLayer(this)
      }
    },
    setStroke (newVal, oldVal) {
      if (newVal === oldVal) return
      this.mapObject.setStyle({ stroke: newVal })
    },
    setFillOpacity (newVal, oldVal) {
      if (newVal === oldVal) return
      this.setInteraction(newVal)
      this.mapObject.setStyle({ fillOpacity: newVal })
    },
    setInteraction (val) {
      if (val !== 0) {
        this.mapObject.dragging.enable()
        this.mapObject.transform.enable()
      } else {
        this.mapObject.dragging.disable()
        this.mapObject.transform.disable()
      }
    },
    updateArea (latLng, size) {
      // console.log('updateArea: init')
      let bound0 = L.latLng(latLng.lat - size.height / 2, latLng.lng + size.width / 2)
      let bound1 = L.latLng(latLng.lat + size.height / 2, latLng.lng + size.width / 2)
      let bound2 = L.latLng(latLng.lat + size.height / 2, latLng.lng - size.width / 2)
      let bound3 = L.latLng(latLng.lat - size.height / 2, latLng.lng - size.width / 2)

      this.sizes = size
      this.latLngs = latLng
      this.bounds = [bound0, bound2]
      this.boundsPoly = [bound0, bound1, bound2, bound3]

      if (this.$refs.areaText) {
        this.$refs.areaText.setLatLng(latLng)
      }
      if (this.mapObject) {
        // console.log('updateArea: new mapObject')
        this.mapObject.setLatLngs(this.boundsPoly)
        // console.log(this.mapObject.transform.enable())
        // this.mapObject.transform.reset()
        // this.mapObject.transform.disable()
        this.mapObject.transform.removeHooks()
        // this.mapObject.transform.enable()
        // this.mapObject.transform.removeHooks()
        this.mapObject.transform.addHooks()
        // this.mapObject.transform.addHooks()
      }
    },
    setLatLng (newVal, oldVal) {
      if (newVal.lat === oldVal.lat && newVal.lng === oldVal.lng) return
      // console.log('setLatLng')
      // console.log(this.mapObject.transform.removeHooks())
      this.updateArea(newVal, this.sizes)
      // console.log(this.mapObject.transform.addHooks())
    },
    setSize (newVal, oldVal) {
      if (newVal.width === oldVal.width && newVal.height === oldVal.height) return
      // console.log('setSize')
      // console.log(this.mapObject.transform.removeHooks())
      this.updateArea(this.latLngs, newVal)
    },
    setTitle (newVal, oldVal) {
      if (newVal === oldVal) return
      if (newVal) {
        this.textVisible = false
        this.text = newVal
        this.textVisible = true
      }
    },
    setTransformable (newVal, oldVal) {
      // console.log(newVal)
    },
    setOpacity (newVal, oldVal) {
      if (newVal === oldVal) return
      if (newVal) {
        this.mapObject.setStyle({ opacity: newVal })
      }
    },
    setInternal (newVal, oldVal) {
      //
    },
    setFill (newVal, oldVal) {
      if (newVal === oldVal) return
      this.mapObject.setStyle({ fill: newVal })
    },
    setClassName (newVal, oldVal) {
      if (newVal === oldVal) return
      if (newVal) {
        this.mapObject.setStyle({ className: newVal })
      }
    }
  }
}
</script>
<style>

    .transform-handler--rotate, .drag-marker--3 + path {
      display: none;
    }

</style>



// WEBPACK FOOTER //
// src/components/LArea.vue